import moment from 'moment-timezone';

const TZ = 'Europe/Rome';

/**
 * Moment object pinned to Europe/Rome.
 * - Naive strings are interpreted as Rome time.
 * - Offset-aware strings are converted to Rome for display.
 */
export const rome = (input?: moment.MomentInput) =>
    moment.tz(input ?? undefined, TZ);

/**
 * Naive ISO string (no offset, no Z) representing Europe/Rome wall-clock time.
 * e.g. "2026-02-19T16:30:00.000"
 */
export const toNaiveISO = (input?: moment.MomentInput) =>
    rome(input).format('YYYY-MM-DDTHH:mm:ss.SSS');

/**
 * "Fake-local" Date whose getFullYear / getMonth / getHours … return
 * Europe/Rome values, so native pickers display Rome wall-clock time.
 */
export const romeDate = (input?: moment.MomentInput): Date => {
    const m = rome(input);
    return new Date(
        m.year(),
        m.month(),
        m.date(),
        m.hours(),
        m.minutes(),
        m.seconds(),
        m.milliseconds(),
    );
};

/**
 * Inverse of romeDate(). Takes a "fake-local" Date (whose getHours etc.
 * represent Rome wall-clock values) and returns a naive ISO string that
 * rome() / romeDate() will correctly round-trip.
 */
export const fromRomeDate = (fakeLocal: Date): string => {
    const p = (n: number, w = 2) => n.toString().padStart(w, '0');
    return `${fakeLocal.getFullYear()}-${p(fakeLocal.getMonth() + 1)}-${p(fakeLocal.getDate())}T${p(fakeLocal.getHours())}:${p(fakeLocal.getMinutes())}:${p(fakeLocal.getSeconds())}.${p(fakeLocal.getMilliseconds(), 3)}`;
};

/**
 * Rome's "now" as a fake-local Date (for date-pickers, shortcuts, etc.).
 */
export const nowRome = (): Date => romeDate();
